import PropTypes from 'prop-types'
import styled, { StyledComponentProps, ThemeProps } from 'styled-components'

interface ProgressBarProps extends StyledComponentProps<'div', any, { percent: number }, never> {
  percent: number
}

type ProgressWindowProps = ProgressBarProps & ThemeProps<any>

const ProgressBarWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 5px;
  background-color: ${(props) => `${props.theme.colors.grey.light}`};
  border-radius: ${(props) => `${props.theme.borderRadius.normal}`};
`

const ProgressBar = styled.div<ProgressWindowProps>`
  position: absolute;
  width: ${(props) => `${props.percent}%`};
  height: 100%;
  background-color: ${(props) =>
    props.percent >= 80
      ? `${props.theme.colors.success.neutral}`
      : props.percent >= 40
      ? `${props.theme.colors.warning.neutral}`
      : `${props.theme.colors.error.neutral}`};
  border-radius: 10px;
`

const ProgressBarComponent = ({ percent }: ProgressBarProps) => {
  return (
    <ProgressBarWrapper>
      <ProgressBar percent={percent} />
    </ProgressBarWrapper>
  )
}

ProgressBarComponent.propTypes = {
  percent: PropTypes.number.isRequired,
}

export default ProgressBarComponent
